var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#DDEBED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.729C27.8003 24.729 30.881 21.6483 30.881 17.848C30.881 14.0478 27.8003 10.967 24 10.967C20.1997 10.967 17.119 14.0478 17.119 17.848C17.119 21.6483 20.1997 24.729 24 24.729Z",
    fill: "#F5FBFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.11 36.2805C11.0894 36.4115 11.1007 36.5454 11.1428 36.6711C11.1849 36.7967 11.2567 36.9104 11.352 37.0025C14.7374 40.2996 19.2763 42.1447 24.002 42.1447C28.7276 42.1447 33.2665 40.2996 36.652 37.0025C36.7473 36.9104 36.819 36.7967 36.8611 36.6711C36.9032 36.5454 36.9145 36.4115 36.894 36.2805C36.4957 33.7345 35.2007 31.4146 33.2425 29.7394C31.2843 28.0641 28.7919 27.1439 26.215 27.1445H21.786C19.2095 27.1446 16.7178 28.0652 14.7603 29.7404C12.8027 31.4155 11.5081 33.735 11.11 36.2805Z",
    fill: "#F5FBFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImage);
export default __webpack_public_path__ + "static/media/userImage.70228f69229916460f99225b2ef3726e.svg";
export { ForwardRef as ReactComponent };